import { HaNPage } from "./HaNPage";

type HaNCompound = typeof HaNPage & {
  Page: typeof HaNPage;
};

export const HaN: HaNCompound = Object.assign(HaNPage, {
  Page: HaNPage,
});
